































































/* eslint-disable @typescript-eslint/camelcase */

import Vue from "vue";
import FBService from "../../../services/facebook";
import Campaings from "./Campaigns.vue";
import AudiencesList from "./AudiencesList.vue";
import { State, Action, Mutation } from "vuex-class";
import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";

const namespace = "facebook";

@Component({
  // Specify `components` option.
  // See Vue.js docs for all available options:
  // https://vuejs.org/v2/api/#Options-Data
  components: {
    Campaings,
    AudiencesList
  }
})
export default class Audiences extends Vue {
  @State("facebook") facebook: FacebookState;
  @Action("fetchAudiences", { namespace }) fetchAudiences: any;
  @Mutation("resetCampaigns", { namespace }) resetCampaigns: any;

  loading = false;
  title = "";
  headers = [
    {
      text: "Name",
      value: "name",
      sortable: false
    },
    {
      text: "Status",
      value: "status",
      sortable: false
    }
  ];

  get selectedAdSets() {
    return this.$store.state.facebook.selectedCampaigns.map(
      ({
        adsets: {
          data: [adset]
        }
      }: {
        adsets: { data: any[] };
      }) => adset
    );
  }

  creatingAudience = {
    name: "",
    subtype: "LOOKALIKE",
    lookalike_spec: {
      origin_ids: [],
      starting_ratio: 0.03,
      ratio: 0.05,
      conversion_type: "campaign_conversions",
      location_spec: {
        geo_locations: {
          countries: ["US"],
          country_groups: []
        }
      }
    }
  };

  // components = {
  //   Campaings
  // };

  beforeRouteUpdate(to: any, from: any, next: Function) {
    this.fetchAudiences({ accountId: to.params.accountId });
    next();
  }

  created() {
    this.fetchAudiences({ accountId: this.$route.params.accountId });
  }

  createAudience() {
    this.creatingAudience.lookalike_spec.origin_ids = this.selectedAdSets.map(
      ({ id }: { id: string }) => id
    );
    this.creatingAudience.lookalike_spec.location_spec.geo_locations.countries = [
      ...new Set(
        this.selectedAdSets
          .map(
            ({
              targeting: {
                geo_locations: { countries }
              }
            }: {
              targeting: { geo_locations: { countries: any[] } };
            }) => countries
          )
          .filter((e: unknown) => e)
          .flatMap((e: unknown) => e)
      )
    ] as string[];
    this.creatingAudience.lookalike_spec.location_spec.geo_locations.country_groups = [
      ...new Set(
        this.selectedAdSets
          .map(
            ({
              targeting: {
                geo_locations: { country_groups }
              }
            }: {
              targeting: { geo_locations: { country_groups: any[] } };
            }) => country_groups
          )
          .filter((e: unknown) => e)
          .flatMap((e: unknown) => e)
      )
    ] as never[];
    FBService.createAudience(
      this.$route.params.accountId,
      this.creatingAudience
    )
      .then(() => {
        this.resetCampaigns();
        this.fetchAudiences({ accountId: this.$route.params.accountId });
      })
      .catch(e => {
        window.alert(e.response.data.error.message);
      });
  }
}
